import { Receipt } from 'lucide-react';
import { useWallet } from '../../../../context/wallet/WalletContext';
import WalletTransactionMobileCard from './WalletTransactionMobileCard';

const WalletMobileTransactionsList = () => {
  const { isLoading, filteredTransactions } = useWallet();

  return (
    <div className="block md:hidden divide-y divide-slate-100">
      {isLoading ? (
        <div className="p-8 text-center text-slate-400 text-xs">
          <div className="w-6 h-6 border-2 border-[#067978] border-t-transparent rounded-full animate-spin mx-auto mb-2" />
          Loading wallet transactions...
        </div>
      ) : filteredTransactions.length === 0 ? (
        <div className="p-8 text-center text-slate-400">
          <div className="w-10 h-10 rounded-2xl bg-slate-50 border border-dashed border-slate-200 flex items-center justify-center mx-auto mb-2 text-slate-400">
            <Receipt size={20} />
          </div>
          <p className="text-xs font-semibold text-slate-700">No transactions found</p>
          <p className="text-[11px] text-slate-400 mt-0.5">Earnings will appear here automatically.</p>
        </div>
      ) : (
        filteredTransactions.map((tx) => (
          <WalletTransactionMobileCard key={tx._id} tx={tx} />
        ))
      )}
    </div>
  );
};

export default WalletMobileTransactionsList;
